// js cookie
import Cookies from 'js-cookie'
window.jsCookies = Cookies;

// window loaded
window.addEventListener('load', function () {
    // set fixed header variable globally
    window.fixedHeader = document.querySelector('#fixed-header');

    // handle menu toggles click
    window.menuToggles = document.querySelectorAll('.menu-toggle');
    window.menuToggles.forEach(function (toggle) {
        toggle.addEventListener('click', toggleMenu);
    });

    // handle menu overlay click
    const menuOverlay = document.querySelector('#menu-overlay');
    menuOverlay.addEventListener('click', toggleMenu);
});

window.toggleMenu = function () {
    const menu = document.querySelector('#menu');
    if (menu.classList.contains('active')) {
        menu.classList.remove('active');
    } else {
        menu.classList.add('active');
    }
}

// window scroll
window.addEventListener('scroll', function () {
    // fixed header activation
    if (window.fixedHeader) {
        if (window.scrollY < 50) {
            window.fixedHeader.classList.remove('active');
        } else {
            window.fixedHeader.classList.add('active');
        }
    }
});